import type { ComponentMetaInput } from '../../ui';
import { INTIMACY_TOP } from '../presets/layout';

export function intimacyControlMeta(top = INTIMACY_TOP) {
  return {
    label: { id: 'presets.editor.intimacy.label', page: 'presets', role: 'text', label: '亲密系统', layout: { x: 16, y: top, width: 260, height: 32 }, zIndex: 5, notes: '亲密系统字段标签；安卓用 TextView' },
    switch: { id: 'presets.editor.intimacy.switch', page: 'presets', role: 'button', label: '亲密系统', layout: { x: 312, y: top, width: 62, height: 32 }, zIndex: 6, notes: '后端权威启用状态与账号隔离；安卓用 SwitchMaterial' },
    status: { id: 'presets.editor.intimacy.status', page: 'presets', role: 'text', label: '亲密系统状态', layout: { x: 16, y: top + 38, width: 358, height: 34 }, zIndex: 5, notes: '加载、登录和同步错误提示；安卓用 TextView' },
  } satisfies Record<string, ComponentMetaInput>;
}
